<template>
  <div>
    <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
      <b-row class="mb-4 mt-2">
        <b-col cols="12" md="6">
          <Label label="Tipo de cerradura" :blank="controlAcceso.motor_id"/>

          <b-row align-h="center" class="mt-3">
            <SelectableCard
              emptyTitle="No hay ninguna cerradura seleccionada"
              :selected="controlAcceso.motor_id ? true : false"
              @open-selectable="$store.commit('setOpenModalName', 'motorSelector')"
            >
              <template #title>
                <span v-if="controlAcceso.motor_id">{{ controlAcceso.motor.item_code || '-' }}</span>
                <span v-else>Seleccione un tipo de cerradura</span>
              </template>
              <template #selected-content>
                <b-row align-h="center" class="img-container">
                  <b-img v-if="controlAcceso.motor_image_url" :src="controlAcceso.motor_image_url" />
                  <div v-else class="d-flex align-items-center justify-content-center" style="width: 100px; height: 50px;">
                    <font-awesome-icon :icon="['far', 'image']" size="2x" class="text-muted" fixed-width />
                  </div>
                </b-row>
                <div class="mt-3 self-align-end">
                  <Button
                    variant="blue"
                    @click="$store.commit('setOpenModalName', 'motorSelector')"
                  >
                    Cambiar
                  </Button>
                </div>
              </template>
            </SelectableCard>
          </b-row>
        </b-col>
        <b-col cols="12" md="6" class="mt-3 mt-md-0">
          <div class="image-wrapper">
            <b-img
              :src="doorDetail"
              fluid
              class="door-detail-img"
            />
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="px-0">
          <div
            v-for="field in dimensionFields"
            :key="field.model"
            class="mb-3"
          >
            <b-row align-v="center">
              <b-col cols="12" md="8" class="mb-2 mb-md-0 px-0">
                <Label
                  :label="field.label"
                  :blank="detailsForm[field.model] === null || detailsForm[field.model] === '' ? null : 'true'"
                  :show-reset="detailsForm[field.model] > 0"
                  @reset="detailsForm[field.model] = 0"
                />
              </b-col>
              <b-col
                cols="12"
                md="4"
                class="d-flex justify-content-md-end justify-content-start px-0"
              >
                <ValidationProvider :rules="{ required: true, numeric: true }" name="campo" v-slot="{ valid, errors }">
                  <b-input-group append="cm" class="w-100 w-md-auto pr-2">
                    <b-form-input
                      v-model="detailsForm[field.model]"
                      type="number"
                      min="0"
                      step="1"
                      :state="errors[0] ? false : (valid ? true : false)"
                    />
                  </b-input-group>
                </ValidationProvider>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="px-0">
          <div
            v-for="item in fields"
            :key="item.model"
            class="py-2"
          >
            <b-row>
              <b-col cols="12" lg="9" class="px-0 pb-1">
                <Label
                  :label="item.label"
                  :blank="detailsForm[item.model] === null ? null : 'true'"
                  :show-reset="detailsForm[item.model] == true || detailsForm[item.model] == false"
                  @reset="detailsForm[item.model] = null"
                />
              </b-col>

              <b-col cols="12" lg="3" class="text-lg-right mb-md-0 px-0">
                <b-form-group>
                  <b-radio-group size="lg" v-model="detailsForm[item.model]" class="ml-4">
                    <b-radio :value="true">Si</b-radio>
                    <b-radio :value="false">No</b-radio>
                  </b-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row align-h="center" class="mt-5">
        <b-link @click="downloadPedestrianDoorPdf">
          Descargar Pedido Directo Peatonales
        </b-link>
      </b-row>

      <span class="d-none">{{ invalid }}</span>
    </ValidationObserver>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

import Label from '../../Label'
import Button from '../../../../shared/Button'
import SelectableCard from '../../../configurators/SelectableCard'

export default {
  name: 'cerraduraElectronica',
  components: { Label, SelectableCard, Button, ValidationObserver, ValidationProvider},
  props: {
    form: Object,
    detailsForm: Object
  },
  data () {
    return {
      dimensionFields: [
        {
          model: 'door_thickness',
          label: 'Espesor de la puerta (X1)'
        },
        {
          model: 'lock_thickness',
          label: 'Espesor de la cerradura (X2)'
        },
        {
          model: 'handle_height',
          label: 'Altura de la manilla con respecto al centro de la cerradura (X3)'
        },
        {
          model: 'handle_offset',
          label: 'Distancia entre el perfil de la puerta y el centro de la manilla (X4)'
        }
      ],
      fields: [
        { label: "La puerta da al exterior", model: 'exterior_door'},
        { label: "Puerta tiene prevista para la cerradura", model: 'door_prepared_for_lock'},
        { label: "Wifi Fuerte y estable en el lugar de instalación", model: 'has_reliable_wifi'},
        { label: "Configurar dispositivos de proximidad", model: 'configure_proximity'},
        { label: "Configurar código", model: 'configure_code'},
        { label: "Configurar huella", model: 'configure_fingerprint'},
        { label: "Configurar en celular", model: 'configure_mobile'},
        { label: "Requiere invitaciones temporales (código)", model: 'requires_temporary_codes'},
      ],
      doorDetail: require('../../../../../../assets/images/control_acceso/door_detail.png'),
      processing: false
    }
  },
  computed: {
    ...mapState({
      controlAcceso: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    })
  },
  methods: {
    downloadPedestrianDoorPdf () {
      if (this.processing) { return }
      this.processing = true
      this.$http.get(`/api/production/submitals/download_pedestrian_pdf`)
        .then((res) => {
          // console.log(res.data)
          const link = document.createElement('a')
          link.href = res.data
          link.download = 'Pedido Directo Peatonales.pdf'
          link.click()
        })
        .catch(e => console.log(e))
        .finally(this.processing = false)
    }
  }
}
</script>

<style scoped>
.img-container img{
  width: 170px;
  height: 100%;
  object-fit: contain;
  display: block;
}

.image-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.door-detail-img{
  max-width: 100%;
  max-height: 270px;
  width: auto;
  height: auto;
  object-fit: contain;
}
</style>